<template>
  <div id="totalBox">
    <ul class="tableBox">
      <li class="tableList" :class="{active:type==1}" data-type='1' @click="selectTab">企业文化</li>
      <li class="tableList" :class="{active:type==2}" data-type='2' @click="selectTab">商务合作</li>
      <li class="tableList" :class="{active:type==3}" data-type='3' @click="selectTab">联系我们</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Abouttable',
  data: function () {
    return {
      type: '1'
    }
  },
  methods: {
    selectTab: function (e) {
      this.type = e.currentTarget.dataset.type
      if (this.type === '1') {
        document.documentElement.scrollTop = 600
        document.body.scrollTop = 600
      } else if (this.type === '2') {
        document.documentElement.scrollTop = 1450
        document.body.scrollTop = 1450
      } else if (this.type === '3') {
        document.documentElement.scrollTop = 2100
        document.body.scrollTop = 2100
      }
    }
  }
}
</script>

<style scoped>
#totalBox{
  width: 100%;
  height: 60px;
  background-color: RGBA(250, 250, 250, 1);
}
.tableBox{
  width: 1200px;
  height: 60px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.tableList{
  width:140px;
  height:60px;
  font-size:18px;
  font-weight:400;
  color:rgba(35,24,21,1);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.active{
  font-weight:bold;
  color:rgba(35,24,21,1);
  background:rgba(255,182,30,1);
}
</style>



// WEBPACK FOOTER //
// src/components/about/table.vue